import { Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FoMaUserModel } from '../../../views/users-view/models/foma-user.model';
import { UserApiService } from '../api/user-api.service';
import { ListFilter } from '../../models/list-filter';

@Injectable({
    providedIn: 'root'
})
export class UserListService {
    private dataSubject = new BehaviorSubject<FoMaUserModel[] | null>(null);
    data$ = this.dataSubject;

    constructor(private userApiService: UserApiService) { }


    @Output() filterChange = new BehaviorSubject<ListFilter>({
        search: []
    });

    loadFoMaUsers() {
        this.userApiService.getFoMaUsersList().subscribe(data => {
            this.dataSubject.next(data)
        });
    }

    applyFilter(filterValues: ListFilter | undefined) {
        filterValues ? this.filterChange.next(filterValues) : console.log('no filter found');
    }
}